<!-- 4em -->
<svg
  width="72"
  height="68"
  viewBox="0 0 18 17"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17.4375 9.20312L10.5625 15.7656C10.1719 16.1172 9.58594 16.1172 9.23438 15.7266C8.88281 15.3359 8.88281 14.75 9.27344 14.3984L14.4688 9.4375H1.1875C0.640625 9.4375 0.25 9.04688 0.25 8.5C0.25 7.99219 0.640625 7.5625 1.1875 7.5625H14.4688L9.27344 2.64062C8.88281 2.28906 8.88281 1.66406 9.23438 1.3125C9.58594 0.921875 10.2109 0.921875 10.5625 1.27344L17.4375 7.83594C17.6328 8.03125 17.75 8.26562 17.75 8.5C17.75 8.77344 17.6328 9.00781 17.4375 9.20312Z"
    fill="white"
  />
</svg>
